import { a1, a2, a3, a4, a5 } from '../assets/data/admins/adm';
import { banner, icon } from '../assets/data/categories/cat';
import { c1, c2, c3, c4, c5, c6 } from '../assets/data/clients/cr';
import { h1, h10, h11, h12, h2, h3, h4, h5, h6, h7, h8, h9 } from '../assets/data/hellocians/hl';
import { uia1, uia2, uia3, uia4 } from '../assets/data/thumbnails/tb';

export const gigs = [

  {
    "id": 1,
    "title": "I will design amazing website with good UX design",
    "thumbnails": [
      { "id": 1, "img": uia1 },
      { "id": 2, "img": uia2 },
      { "id": 3, "img": uia3 },
      { "id": 4, "img": uia4 }
    ],
    "rating": 4.8,
    "sells": 104,
    "admin_id": 1,
    "deliveries": [
      { "id": 1, "rate": "slow" },
      { "id": 2, "rate": "express" },
      { "id": 3, "rate": "fast" },
      { "id": 4, "rate": "extra fast" },
      { "id": 5, "rate": "normal" }
    ],
    "hellocians": [{ "id": 1 }, { "id": 2 }, { "id": 3 }],
    "categories": [{ "id": 1 }, { "id": 2 }],
    "reviews": [{ "id": 1 }, { "id": 3 }, { "id": 4 }],
    "about": "Welcome to my professional website design gig! Are you looking to establish a strong online presence for your business or personal brand? Look no further! With my expertise in web design, I will create a stunning, functional, and user-friendly website tailored to your needs.What You'll Get:Custom Design: I will design a unique website that reflects your brand identity and resonates with your target audience.Responsive Layout: Your website will be fully responsive, ensuring seamless viewing experience across all devices, from desktops to smartphones. User-friendly Interface: I prioritize usability and navigation, making sure visitors can easily find what they're looking for and engage with your content. SEO Optimization: I will implement basic SEO practices to help improve your website's visibility on search engines like Google. Integration: If you require advanced features like social media integration, or e-commerce functionality, I'll incorporate the necessary features to meet your goals.",
    "pricingPlans": [
      {
        "title": "Basic",
        "features": [
          "Responsive web design",
          "3 Revisions",
          "Basic web page",
          "Mobile friendly design"
        ],
        "benefits": {
          "unlimitedRevisions": true,
          "functionalWebsite": true,
          "paymentProcess": false,
          "legalForms": false
        }
      },
      {
        "title": "Standard",
        "features": [
          "Responsive web design",
          "5 Revisions",
          "Extra web page",
          "Responsive web design"
        ],
        "benefits": {
          "unlimitedRevisions": true,
          "functionalWebsite": true,
          "paymentProcess": true,
          "legalForms": false
        }
      },
      {
        "title": "Advanced",
        "features": [
          "Responsive web design",
          "7 Revisions",
          "Extra web page",
          "Responsive web design"
        ],
        "benefits": {
          "unlimitedRevisions": true,
          "functionalWebsite": true,
          "paymentProcess": true,
          "legalForms": false
        }
      },
      {
        "title": "Pro",
        "features": [
          "Responsive web design",
          "7 Revisions",
          "Extra web page",
          "Responsive web design"
        ],
        "benefits": {
          "unlimitedRevisions": true,
          "functionalWebsite": true,
          "paymentProcess": true,
          "legalForms": true
        }
      },
      {
        "title": "Premium",
        "features": [
          "Responsive web design",
          "9 Revisions",
          "Extra web page",
          "Responsive web design"
        ],
        "benefits": {
          "unlimitedRevisions": true,
          "functionalWebsite": true,
          "paymentProcess": true,
          "legalForms": true
        }
      }
    ]
  },
  {
    "id": 2,
    "title": "I will create responsive mobile-first website designs",
    "thumbnails": [
      { "id": 1, "img": uia1 },
      { "id": 2, "img": uia1 },
      { "id": 3, "img": uia3 },
      { "id": 4, "img": uia4 }
    ],
    "rating": 4.6,
    "sells": 233,
    "admin_id": 2,
    "deliveries": [
      { "id": 1, "rate": "normal" },
      { "id": 2, "rate": "express" },
      { "id": 3, "rate": "fast" },
      { "id": 4, "rate": "extra fast" }
    ],
    "hellocians": [{ "id": 3 }, { "id": 1 }],
    "categories": [{ "id": 3 }],
    "reviews": [{ "id": 5 }, { "id": 6 }, { "id": 2 }],
    "about": "Are you struggling with mobile traffic? I specialize in creating beautiful, responsive websites that look amazing on all devices. With mobile traffic accounting for over 60% of web browsing, having a mobile-first approach is crucial for success. My designs focus on speed, usability, and conversion optimization for smartphones and tablets while maintaining a professional look on desktop. I'll ensure your site loads quickly and functions perfectly regardless of device or screen size. With years of experience in responsive design, I can transform your existing website or build a new one from scratch with mobile users in mind.",
    "pricingPlans": [
      {
        "title": "Starter",
        "features": [
          "3-page responsive design",
          "2 Revisions",
          "Mobile optimization",
          "Basic SEO structure"
        ],
        "benefits": {
          "unlimitedRevisions": false,
          "functionalWebsite": true,
          "paymentProcess": false,
          "legalForms": false
        }
      },
      {
        "title": "Business",
        "features": [
          "5-page responsive design",
          "4 Revisions",
          "Mobile & tablet optimization",
          "Advanced SEO structure"
        ],
        "benefits": {
          "unlimitedRevisions": false,
          "functionalWebsite": true,
          "paymentProcess": true,
          "legalForms": false
        }
      },
      {
        "title": "Enterprise",
        "features": [
          "8-page responsive design",
          "6 Revisions",
          "All device optimization",
          "Performance optimization"
        ],
        "benefits": {
          "unlimitedRevisions": true,
          "functionalWebsite": true,
          "paymentProcess": true,
          "legalForms": true
        }
      }
    ]
  },
  {
    "id": 3,
    "title": "I will design a professional and memorable logo",
    "thumbnails": [
      { "id": 1, "img": uia3 },
      { "id": 2, "img": uia4 },
      { "id": 3, "img": uia2 },
      { "id": 4, "img": uia3 }
    ],
    "rating": 5.0,
    "sells": 4,
    "admin_id": 2,
    "deliveries": [
      { "id": 1, "rate": "standard" },
      { "id": 2, "rate": "premium" },
      { "id": 3, "rate": "rush" }
    ],
    "hellocians": [{ "id": 5 }, { "id": 2 }],
    "categories": [{ "id": 3 }, { "id": 1 }],
    "reviews": [{ "id": 5 }, { "id": 6 }, { "id": 7 }, { "id": 8 }],
    "about": "Looking for a logo that stands out and represents your brand perfectly? I create custom logos that are not only visually appealing but also meaningful and relevant to your business. With over 8 years of experience in graphic design, I understand the importance of a strong visual identity. Your logo is often the first impression potential customers have of your business, and I'm committed to making it a lasting one. I'll work closely with you to understand your vision, values, and target audience to create a logo that resonates with your ideal customers and sets you apart from competitors.",
    "pricingPlans": [
      {
        "title": "Essential",
        "features": [
          "2 unique concepts",
          "3 Revisions",
          "High resolution files",
          "Basic color variations"
        ],
        "benefits": {
          "unlimitedRevisions": false,
          "functionalWebsite": false,
          "paymentProcess": false,
          "legalForms": false
        }
      },
      {
        "title": "Professional",
        "features": [
          "4 unique concepts",
          "5 Revisions",
          "Source files included",
          "Social media kit"
        ],
        "benefits": {
          "unlimitedRevisions": false,
          "functionalWebsite": false,
          "paymentProcess": false,
          "legalForms": true
        }
      },
      {
        "title": "Premium Branding",
        "features": [
          "6 unique concepts",
          "Unlimited revisions",
          "Complete brand package",
          "Business card design"
        ],
        "benefits": {
          "unlimitedRevisions": true,
          "functionalWebsite": false,
          "paymentProcess": true,
          "legalForms": true
        }
      }
    ]
  },
  {
    "id": 4,
    "title": "I will develop custom e-commerce solutions",
    "thumbnails": [
      { "id": 1, "img": uia1 },
      { "id": 2, "img": uia2 },
      { "id": 3, "img": uia3 },
      { "id": 4, "img": uia4 }
    ],
    "rating": 4.7,
    "sells": 4,
    "admin_id": 3,
    "deliveries": [
      { "id": 1, "rate": "standard" },
      { "id": 2, "rate": "expedited" },
      { "id": 3, "rate": "priority" }
    ],
    "hellocians": [{ "id": 6 }, { "id": 4 }],
    "categories": [{ "id": 5 }, { "id": 6 }, { "id": 7 }],
    "reviews": [{ "id": 9 }, { "id": 10 }, { "id": 11 }, { "id": 12 }],
    "about": "Ready to take your online store to the next level? I specialize in building custom e-commerce solutions that drive sales and improve customer experience. Whether you need a new online store built from scratch or improvements to your existing platform, I can help. I work with popular e-commerce platforms including Shopify, WooCommerce, and Magento, creating customized solutions tailored to your specific business needs. From payment gateway integration and inventory management to custom product configurations and automated marketing tools, I'll build a solution that helps your business grow and succeed in the competitive online marketplace.",
    "pricingPlans": [
      {
        "title": "Store Setup",
        "features": [
          "Platform installation",
          "Basic theme customization",
          "Up to 50 products",
          "Payment gateway setup"
        ],
        "benefits": {
          "unlimitedRevisions": false,
          "functionalWebsite": true,
          "paymentProcess": true,
          "legalForms": false
        }
      },
      {
        "title": "Business Store",
        "features": [
          "Advanced customization",
          "Up to 200 products",
          "Multiple payment options",
          "Inventory management"
        ],
        "benefits": {
          "unlimitedRevisions": false,
          "functionalWebsite": true,
          "paymentProcess": true,
          "legalForms": true
        }
      },
      {
        "title": "Enterprise Solution",
        "features": [
          "Custom feature development",
          "Unlimited products",
          "API integrations",
          "Analytics setup"
        ],
        "benefits": {
          "unlimitedRevisions": true,
          "functionalWebsite": true,
          "paymentProcess": true,
          "legalForms": true
        }
      }
    ]
  },
  {
    "id": 5,
    "title": "I will create eye-catching social media graphics",
    "thumbnails": [
      { "id": 1, "img": uia1 },
      { "id": 2, "img": uia2 },
      { "id": 3, "img": uia3 },
      { "id": 4, "img": uia4 }
    ],
    "rating": 4.5,
    "sells": 4,
    "admin_id": 4,
    "deliveries": [
      { "id": 1, "rate": "basic" },
      { "id": 2, "rate": "standard" },
      { "id": 3, "rate": "premium" }
    ],
    "hellocians": [{ "id": 2 }, { "id": 1 }, { "id": 3 }],
    "categories": [{ "id": 1 }, { "id": 4 }, { "id": 3 }],
    "reviews": [{ "id": 1 }, { "id": 4 }, { "id": 11 }, { "id": 3 }],
    "about": "Want to stand out on social media? I create scroll-stopping graphics that grab attention and increase engagement. In today's crowded social media landscape, eye-catching visuals are essential for cutting through the noise. I design custom graphics for all social platforms including Instagram, Facebook, Twitter, LinkedIn, and TikTok. Whether you need post graphics, stories, covers, or ads, I'll create cohesive visuals that strengthen your brand identity and connect with your audience. My designs combine current trends with timeless design principles to ensure your content not only looks great but also drives results.",
    "pricingPlans": [
      {
        "title": "Social Starter",
        "features": [
          "5 social media graphics",
          "2 platforms optimized",
          "2 Revisions",
          "Basic templates"
        ],
        "benefits": {
          "unlimitedRevisions": false,
          "functionalWebsite": false,
          "paymentProcess": false,
          "legalForms": false
        }
      },
      {
        "title": "Content Pack",
        "features": [
          "10 social media graphics",
          "4 platforms optimized",
          "3 Revisions",
          "Custom templates"
        ],
        "benefits": {
          "unlimitedRevisions": false,
          "functionalWebsite": false,
          "paymentProcess": false,
          "legalForms": false
        }
      },
      {
        "title": "Monthly Bundle",
        "features": [
          "20 social media graphics",
          "All platforms optimized",
          "4 Revisions",
          "Content calendar"
        ],
        "benefits": {
          "unlimitedRevisions": false,
          "functionalWebsite": false,
          "paymentProcess": true,
          "legalForms": false
        }
      }
    ]
  }
  ,
  {
    "id": 5,
    "title": "I will create eye-catching social media graphics",
    "thumbnails": [
      { "id": 1, "img": uia1 },
      { "id": 2, "img": uia2 },
      { "id": 3, "img": uia3 },
      { "id": 4, "img": uia4 }
    ],
    "rating": 4.5,
    "sells": 4,
    "admin_id": 6,
    "deliveries": [
      { "id": 1, "rate": "basic" },
      { "id": 2, "rate": "standard" },
      { "id": 3, "rate": "premium" }
    ],
    "about": "Want to stand out on social media? I create scroll-stopping graphics that grab attention and increase engagement. In today's crowded social media landscape, eye-catching visuals are essential for cutting through the noise. I design custom graphics for all social platforms including Instagram, Facebook, Twitter, LinkedIn, and TikTok. Whether you need post graphics, stories, covers, or ads, I'll create cohesive visuals that strengthen your brand identity and connect with your audience. My designs combine current trends with timeless design principles to ensure your content not only looks great but also drives results.",
    "pricingPlans": [
      {
        "title": "Social Starter",
        "features": [
          "5 social media graphics",
          "2 platforms optimized",
          "2 Revisions",
          "Basic templates"
        ],
        "benefits": {
          "unlimitedRevisions": false,
          "functionalWebsite": false,
          "paymentProcess": false,
          "legalForms": false
        }
      },
      {
        "title": "Content Pack",
        "features": [
          "10 social media graphics",
          "4 platforms optimized",
          "3 Revisions",
          "Custom templates"
        ],
        "benefits": {
          "unlimitedRevisions": false,
          "functionalWebsite": false,
          "paymentProcess": false,
          "legalForms": false
        }
      },
      {
        "title": "Monthly Bundle",
        "features": [
          "20 social media graphics",
          "All platforms optimized",
          "4 Revisions",
          "Content calendar"
        ],
        "benefits": {
          "unlimitedRevisions": false,
          "functionalWebsite": false,
          "paymentProcess": true,
          "legalForms": false
        }
      }
    ]
  },
  {
    "id": 6,
    "title": "I will optimize your website for speed and performance",
    "thumbnails": [
      { "id": 5, "img": uia4 },
      { "id": 6, "img": uia1 },
      { "id": 7, "img": uia2 },
      { "id": 8, "img": uia3 }
    ],
    "rating": 4.9,
    "sells": 10,
    "admin_id": 7,
    "deliveries": [
      { "id": 4, "rate": "basic" },
      { "id": 5, "rate": "premium" },
      { "id": 6, "rate": "urgent" }
    ],
    "about": "Is your website loading too slowly? Slow loading times lead to high bounce rates and lost conversions. I'll optimize your website for maximum speed and performance, improving user experience and search engine rankings. Using a combination of technical expertise and proven optimization techniques, I'll identify and fix the issues slowing down your site. Services include image optimization, code minification, server response time improvement, browser caching setup, and more. After optimization, you'll receive a detailed report showing before and after metrics, as well as recommendations for maintaining optimal performance.",
    "pricingPlans": [
      {
        "title": "Quick Fix",
        "features": [
          "Basic speed audit",
          "Image optimization",
          "Cache setup",
          "Performance report"
        ],
        "benefits": {
          "unlimitedRevisions": false,
          "functionalWebsite": true,
          "paymentProcess": false,
          "legalForms": false
        }
      },
      {
        "title": "Full Optimization",
        "features": [
          "Comprehensive audit",
          "Code optimization",
          "Server configuration",
          "CDN setup"
        ],
        "benefits": {
          "unlimitedRevisions": false,
          "functionalWebsite": true,
          "paymentProcess": false,
          "legalForms": true
        }
      },
      {
        "title": "Enterprise Speed",
        "features": [
          "Advanced optimization",
          "Database tuning",
          "Custom solutions",
          "30-day monitoring"
        ],
        "benefits": {
          "unlimitedRevisions": true,
          "functionalWebsite": true,
          "paymentProcess": true,
          "legalForms": true
        }
      }
    ]
  },
  {
    "id": 7,
    "title": "I will create custom WordPress themes and plugins",
    "thumbnails": [
      { "id": 9, "img": uia1 },
      { "id": 10, "img": uia2 },
      { "id": 11, "img": uia3 },
      { "id": 12, "img": uia4 }
    ],
    "rating": 4.8,
    "sells": 15,
    "admin_id": 8,
    "deliveries": [
      { "id": 7, "rate": "standard" },
      { "id": 8, "rate": "expedited" },
      { "id": 9, "rate": "priority" }
    ],
    "about": "Need a custom WordPress solution that stands out from generic themes? I create tailor-made WordPress themes and plugins designed specifically for your business needs. With over 10 years of WordPress development experience, I build clean, efficient, and feature-rich WordPress solutions. Whether you need a custom theme that perfectly represents your brand or a specialized plugin to add unique functionality to your site, I'll work with you to understand your requirements and deliver a solution that exceeds expectations. All my themes are responsive, SEO-friendly, and compatible with popular WordPress plugins.",
    "pricingPlans": [
      {
        "title": "Theme Customization",
        "features": [
          "Existing theme modification",
          "5 custom page templates",
          "Mobile responsiveness",
          "Basic SEO setup"
        ],
        "benefits": {
          "unlimitedRevisions": false,
          "functionalWebsite": true,
          "paymentProcess": false,
          "legalForms": false
        }
      },
      {
        "title": "Custom Theme",
        "features": [
          "Custom theme from scratch",
          "8 page templates",
          "Custom post types",
          "Advanced theme options"
        ],
        "benefits": {
          "unlimitedRevisions": false,
          "functionalWebsite": true,
          "paymentProcess": true,
          "legalForms": false
        }
      },
      {
        "title": "Theme + Plugin Package",
        "features": [
          "Custom theme",
          "Custom plugin development",
          "Advanced functionality",
          "30-day support"
        ],
        "benefits": {
          "unlimitedRevisions": true,
          "functionalWebsite": true,
          "paymentProcess": true,
          "legalForms": true
        }
      }
    ]
  },
  {
    "id": 8,
    "title": "I will build an SEO-optimized landing page that converts",
    "thumbnails": [
      { "id": 1, "img": uia2 },
      { "id": 2, "img": uia3 },
      { "id": 3, "img": uia1 },
      { "id": 4, "img": uia3 }
    ],
    "rating": 4.7,
    "sells": 8,
    "admin_id": 10,
    "deliveries": [
      { "id": 1, "rate": "standard" },
      { "id": 2, "rate": "rush" },
      { "id": 3, "rate": "express" }
    ],
    "about": "Want to turn visitors into customers? I design and develop high-converting landing pages optimized for both search engines and conversions. Your landing page is often the first interaction potential customers have with your business, and it needs to make a strong impression. I combine persuasive copywriting, strategic design, and technical SEO to create landing pages that rank well in search results and convert visitors into leads or customers. Using proven psychological triggers, clear call-to-actions, and conversion-focused layouts, I'll help you maximize the return on your marketing investment with a landing page that generates results.",
    "pricingPlans": [
      {
        "title": "Basic Landing",
        "features": [
          "Single-page design",
          "On-page SEO",
          "Mobile responsive",
          "Contact form integration"
        ],
        "benefits": {
          "unlimitedRevisions": false,
          "functionalWebsite": true,
          "paymentProcess": false,
          "legalForms": false
        }
      },
      {
        "title": "Pro Conversion",
        "features": [
          "Advanced landing page",
          "A/B testing setup",
          "Email capture integration",
          "Conversion tracking"
        ],
        "benefits": {
          "unlimitedRevisions": false,
          "functionalWebsite": true,
          "paymentProcess": true,
          "legalForms": false
        }
      },
      {
        "title": "Elite Sales Funnel",
        "features": [
          "Multi-page funnel",
          "Advanced analytics",
          "Payment integration",
          "Retargeting setup"
        ],
        "benefits": {
          "unlimitedRevisions": true,
          "functionalWebsite": true,
          "paymentProcess": true,
          "legalForms": true
        }
      }
    ]
  },
  {
    "id": 9,
    "title": "I will design professional UI/UX for web and mobile apps",
    "thumbnails": [
      { "id": 5, "img": uia2 },
      { "id": 6, "img": uia1 },
      { "id": 7, "img": uia1 },
      { "id": 8, "img": uia3 }
    ],
    "rating": 4.9,
    "sells": 12,
    "admin_id": 11,
    "deliveries": [
      { "id": 4, "rate": "standard" },
      { "id": 5, "rate": "expedited" },
      { "id": 6, "rate": "priority" }
    ],
    "about": "Are users struggling with your app or website? I create intuitive, beautiful UI/UX designs that delight users and achieve business goals. With expertise in both user interface and user experience design, I deliver comprehensive design solutions for web and mobile applications. My process includes user research, information architecture, wireframing, prototyping, and final UI design. I focus on creating intuitive interfaces that guide users effectively through your digital product while maintaining visual appeal and brand consistency. Whether you're launching a new product or improving an existing one, I'll help you create an exceptional user experience that drives engagement and conversion.",
    "pricingPlans": [
      {
        "title": "UI Refresh",
        "features": [
          "Visual redesign",
          "Style guide",
          "2 revision rounds",
          "Source files included"
        ],
        "benefits": {
          "unlimitedRevisions": false,
          "functionalWebsite": false,
          "paymentProcess": false,
          "legalForms": false
        }
      },
      {
        "title": "UX Solution",
        "features": [
          "User research",
          "Wireframes",
          "Interactive prototype",
          "Usability testing"
        ],
        "benefits": {
          "unlimitedRevisions": false,
          "functionalWebsite": false,
          "paymentProcess": false,
          "legalForms": true
        }
      },
      {
        "title": "Complete UI/UX",
        "features": [
          "Full design process",
          "Multiple iterations",
          "Design system",
          "Implementation guidance"
        ],
        "benefits": {
          "unlimitedRevisions": true,
          "functionalWebsite": false,
          "paymentProcess": true,
          "legalForms": true
        }
      }
    ]
  },
  {
    "id": 10,
    "title": "Professional graphic design for logos, brochures, and business cards",
    "thumbnails": [
      { "id": 9, "img": uia1 },
      { "id": 10, "img": uia2 },
      { "id": 11, "img": uia3 },
      { "id": 12, "img": uia4 }
    ],
    "rating": 4.8,
    "sells": 18,
    "admin_id": 12,
    "deliveries": [
      { "id": 7, "rate": "standard" },
      { "id": 8, "rate": "expedited" }
    ],
    "about": "Need a professional graphic design that captures your brand's essence? I offer custom graphic design services for logos, brochures, business cards, and more. With expertise in Adobe Creative Suite, I'll create visually stunning designs that elevate your brand.",
    "pricingPlans": [
      {
        "title": "Basic",
        "features": [
          "2 design concepts",
          "1 revision round",
          "jpeg file"
        ],
        "benefits": {
          "unlimitedRevisions": false,
          "vectorFiles": false
        }
      },
      {
        "title": "Premium",
        "features": [
          "4 design concepts",
          "2 revision rounds",
          "vector files"
        ],
        "benefits": {
          "unlimitedRevisions": false,
          "vectorFiles": true
        }
      },
      {
        "title": "Ultimate",
        "features": [
          "6 design concepts",
          "unlimited revisions",
          "vector files",
          "style guide"
        ],
        "benefits": {
          "unlimitedRevisions": true,
          "vectorFiles": true
        }
      }
    ]
  },
  {
    "id": 11,
    "title": "Custom web development for businesses and e-commerce",
    "thumbnails": [
      { "id": 1, "img": uia1 },
      { "id": 2, "img": uia2 },
      { "id": 3, "img": uia3 },
      { "id": 4, "img": uia4 }
    ],
    "rating": 4.9,
    "sells": 20,
    "admin_id": 2,
    "deliveries": [
      { "id": 1, "rate": "standard" },
      { "id": 2, "rate": "expedited" },
      { "id": 3, "rate": "priority" }
    ],
    "about": "Need a custom web solution for your business or e-commerce platform? I offer web development services that cater to your specific needs. With expertise in HTML, CSS, JavaScript, and more, I'll create a website that drives engagement and conversion.",
    "pricingPlans": [
      {
        "title": "Basic",
        "features": [
          "5-page website",
          "responsive design",
          "1 revision round"
        ],
        "benefits": {
          "eCommerce": false,
          "unlimitedRevisions": false
        }
      },
      {
        "title": "Premium",
        "features": [
          "10-page website",
          "e-commerce integration",
          "2 revision rounds"
        ],
        "benefits": {
          "eCommerce": true,
          "unlimitedRevisions": false
        }
      },
      {
        "title": "Ultimate",
        "features": [
          "custom website",
          "e-commerce integration",
          "unlimited revisions",
          "maintenance support"
        ],
        "benefits": {
          "eCommerce": true,
          "unlimitedRevisions": true
        }
      }
    ]
  },
  {
    "id": 12,
    "title": "Expert digital marketing services for businesses",
    "thumbnails": [
      { "id": 5, "img": uia2 },
      { "id": 6, "img": uia3 },
      { "id": 7, "img": uia1 },
      { "id": 8, "img": uia4 }
    ],
    "rating": 4.7,
    "sells": 22,
    "admin_id": 3,
    "deliveries": [
      { "id": 4, "rate": "standard" },
      { "id": 5, "rate": "expedited" }
    ],
    "about": "Need expert digital marketing services to boost your online presence? I offer custom digital marketing solutions that cater to your specific needs. With expertise in SEO, social media marketing, and more, I'll help you drive engagement and conversion.",
    "pricingPlans": [
      {
        "title": "Basic",
        "features": [
          "SEO audit",
          "social media setup",
          "1 revision round"
        ],
        "benefits": {
          "unlimitedRevisions": false,
          "monthlyReporting": false
        }
      },
      {
        "title": "Premium",
        "features": [
          "SEO optimization",
          "social media management",
          "2 revision rounds"
        ],
        "benefits": {
          "unlimitedRevisions": false,
          "monthlyReporting": true
        }
      },
      {
        "title": "Ultimate",
        "features": [
          "custom digital marketing strategy",
          "SEO optimization",
          "social media management",
          "unlimited revisions",
          "monthly reporting"
        ],
        "benefits": {
          "unlimitedRevisions": true,
          "monthlyReporting": true
        }
      }
    ]
  }

]

export const hellocians = [
  {
    "id": 1,
    "name": "Mikel Obi",
    "username": "mikel72",
    "profilePicture": h1,
    "available": true,
    "rating": 4.1,
    "deliveries": [
      { "id": 1, "rate": "normal" },
      { "id": 2, "rate": "normal" },
      { "id": 3, "rate": "fast" },
      { "id": 4, "rate": "extra fast" },
      { "id": 5, "rate": "normal" }
    ],
    "keywords": [
      { "id": 1, "name": "Web Development" },
      { "id": 2, "name": "Machine Learning" }
    ]
  },
  {
    "id": 2,
    "name": "Adeola Jess",
    "username": "adeojess",
    "profilePicture": h2,
    "available": true,
    "rating": 4.5,
    "deliveries": [
      { "id": 1, "rate": "fast" },
      { "id": 2, "rate": "extra fast" },
      { "id": 3, "rate": "normal" },
      { "id": 4, "rate": "fast" },
      { "id": 5, "rate": "extra fast" }
    ],
    "keywords": [
      { "id": 1, "name": "App Development" },
      { "id": 2, "name": "Cloud Computing" }
    ]
  },
  {
    "id": 3,
    "name": "Tunde Ednut",
    "username": "tundeednut",
    "profilePicture": h3,
    "available": false,
    "rating": 4.8,
    "deliveries": [
      { "id": 1, "rate": "extra fast" },
      { "id": 2, "rate": "fast" },
      { "id": 3, "rate": "normal" },
      { "id": 4, "rate": "extra fast" },
      { "id": 5, "rate": "fast" }
    ],
    "keywords": [
      { "id": 1, "name": "Cybersecurity" },
      { "id": 2, "name": "Data Science" }
    ]
  },
  {
    "id": 4,
    "name": "Femi Adebayo",
    "username": "femiade",
    "profilePicture": h4,
    "available": true,
    "rating": 4.3,
    "deliveries": [
      { "id": 1, "rate": "normal" },
      { "id": 2, "rate": "fast" },
      { "id": 3, "rate": "normal" },
      { "id": 4, "rate": "fast" },
      { "id": 5, "rate": "normal" }
    ],
    "keywords": [
      { "id": 1, "name": "Artificial Intelligence" },
      { "id": 2, "name": "Web Development" }
    ]
  },
  {
    "id": 5,
    "name": "Tope Fasakin",
    "username": "topefasa",
    "profilePicture": h5,
    "available": true,
    "rating": 4.6,
    "deliveries": [
      { "id": 1, "rate": "fast" },
      { "id": 2, "rate": "extra fast" },
      { "id": 3, "rate": "fast" },
      { "id": 4, "rate": "extra fast" },
      { "id": 5, "rate": "fast" }
    ],
    "keywords": [
      { "id": 1, "name": "Database Administration" },
      { "id": 2, "name": "Network Security" }
    ]
  },
  {
    "id": 6,
    "name": "Seun Oloketuyi",
    "username": "seunoloke",
    "profilePicture": h6,
    "available": false,
    "rating": 4.9,
    "deliveries": [
      { "id": 1, "rate": "extra fast" },
      { "id": 2, "rate": "extra fast" },
      { "id": 3, "rate": "fast" },
      { "id": 4, "rate": "extra fast" },
      { "id": 5, "rate": "extra fast" }
    ],
    "keywords": [
      { "id": 1, "name": "DevOps" },
      { "id": 2, "name": "Cloud Migration" }
    ]
  },
  {
    "id": 7,
    "name": "Kunle Falana",
    "username": "kunlefa",
    "profilePicture": h7,
    "available": true,
    "rating": 4.4,
    "deliveries": [
      { "id": 1, "rate": "normal" },
      { "id": 2, "rate": "normal" },
      { "id": 3, "rate": "fast" },
      { "id": 4, "rate": "normal" },
      { "id": 5, "rate": "fast" }
    ],
    "keywords": [
      { "id": 1, "name": "Data Analysis" },
      { "id": 2, "name": "Business Intelligence" }
    ]
  },
  {
    "id": 8,
    "name": "Bola Ogungbemi",
    "username": "bolaogun",
    "profilePicture": h8,
    "available": true,
    "rating": 4.7,
    "deliveries": [
      { "id": 1, "rate": "fast" },
      { "id": 2, "rate": "fast" },
      { "id": 3, "rate": "extra fast" },
      { "id": 4, "rate": "fast" },
      { "id": 5, "rate": "extra fast" }
    ],
    "keywords": [
      { "id": 1, "name": "Full Stack Development" },
      { "id": 2, "name": "Backend Development" }
    ]
  },
  {
    "id": 9,
    "name": "Damilola Ogunleye",
    "username": "damilolaogun",
    "profilePicture": h9,
    "available": false,
    "rating": 4.2,
    "deliveries": [
      { "id": 1, "rate": "normal" },
      { "id": 2, "rate": "fast" },
      { "id": 3, "rate": "normal" },
      { "id": 4, "rate": "fast" },
      { "id": 5, "rate": "normal" }
    ],
    "keywords": [
      { "id": 1, "name": "Frontend Development" },
      { "id": 2, "name": "UX/UI Design" }
    ]
  },
  {
    "id": 10,
    "name": "Segun Olaitan",
    "username": "segunolaitan",
    "profilePicture": h10,
    "available": true,
    "rating": 4.0,
    "deliveries": [
      { "id": 1, "rate": "fast" },
      { "id": 2, "rate": "normal" },
      { "id": 3, "rate": "fast" },
      { "id": 4, "rate": "normal" },
      { "id": 5, "rate": "fast" }
    ],
    "keywords": [
      { "id": 1, "name": "Quality Assurance" },
      { "id": 2, "name": "Testing and Deployment" }
    ]
  },
  {
    "id": 11,
    "name": "Nneoma Onwuka",
    "username": "nneomaonwuka",
    "profilePicture": h11,
    "available": true,
    "rating": 4.8,
    "deliveries": [
      { "id": 1, "rate": "extra fast" },
      { "id": 2, "rate": "extra fast" },
      { "id": 3, "rate": "fast" },
      { "id": 4, "rate": "extra fast" },
      { "id": 5, "rate": "extra fast" }
    ],
    "keywords": [
      { "id": 1, "name": "Data Science" },
      { "id": 2, "name": "Artificial Intelligence" }
    ]
  },
  {
    "id": 12,
    "name": "Ayo Adeyemi",
    "username": "ayoadeyemi",
    "imgprofilePicture": h12,
    "available": false,
    "rating": 4.5,
    "deliveries": [
      { "id": 1, "rate": "fast" },
      { "id": 2, "rate": "normal" },
      { "id": 3, "rate": "fast" },
      { "id": 4, "rate": "normal" },
      { "id": 5, "rate": "fast" }
    ],
    "keywords": [
      { "id": 1, "name": "Web Development" },
      { "id": 2, "name": "E-commerce Solutions" }
    ]
  }
]


export const categories = [
  { "id": 1, "name": "Web Development", "thumbnail": banner, isIconImg: true, "icon": icon },
  { "id": 2, "name": "Fullstack Development", "thumbnail": banner, isIconImg: false, "icon": "<>" },
  { "id": 3, "name": "App Development", "thumbnail": banner, isIconImg: true, "icon": icon },
  { "id": 4, "name": "Artificial Intelligence", "thumbnail": banner, isIconImg: false, "icon": "🤖" },
  { "id": 5, "name": "Machine Learning", "thumbnail": banner, isIconImg: true, "icon": icon },
  { "id": 6, "name": "Cybersecurity", "thumbnail": banner, isIconImg: true, "icon": icon },
  { "id": 7, "name": "Data Science", "thumbnail": banner, isIconImg: true, "icon": icon },
  { "id": 8, "name": "Cloud Computing", "thumbnail": banner, isIconImg: false, "icon": "🤖" },
  { "id": 9, "name": "Database Administration", "thumbnail": banner, isIconImg: false, "icon": "🤖" },
  { "id": 10, "name": "DevOps", "thumbnail": banner, isIconImg: false, "icon": "🤖" },
  { "id": 11, "name": "UX/UI Design", "thumbnail": banner, isIconImg: false, "icon": "🖋️" },
  { "id": 12, "name": "Quality Assurance", "thumbnail": banner, isIconImg: false, "icon": "🤖" },
]

export const reviews = [
  { "id": 1, "client_id": 1, "rating": 4, "txt": "He did well and delivered" },
  { "id": 2, "client_id": 2, "rating": 5, "txt": "Excellent work, highly recommended" },
  { "id": 3, "client_id": 3, "rating": 3, "txt": "Good effort, but room for improvement" },
  { "id": 4, "client_id": 1, "rating": 5, "txt": "Fantastic job, exceeded expectations" },
  { "id": 5, "client_id": 4, "rating": 2, "txt": "Disappointing experience, didn't meet expectations" },
  { "id": 6, "client_id": 5, "rating": 4, "txt": "Good communication, delivered on time" },
  { "id": 7, "client_id": 6, "rating": 5, "txt": "Exceptional work, very professional" },
  { "id": 8, "client_id": 7, "rating": 3, "txt": "Average work, could be better" },
  { "id": 9, "client_id": 8, "rating": 4, "txt": "Pleasure working with, good results" },
  { "id": 10, "client_id": 9, "rating": 5, "txt": "Outstanding job, highly impressed" },
  { "id": 11, "client_id": 10, "rating": 2, "txt": "Not satisfied, didn't meet requirements" },
  { "id": 12, "client_id": 1, "rating": 4, "txt": "Good job, would work with again" }
]

export const clients = [
  { "id": 1, "name": "Kelvin Fredo", "username": "kelvonsns", "profilePicture": c1 },
  { "id": 2, "name": "Jane Doe", "username": "janedoe12", "profilePicture": c2 },
  { "id": 3, "name": "John Smith", "username": "johnsmith23", "profilePicture": c3 },
  { "id": 4, "name": "Emily Chen", "username": "emilychen34", "profilePicture": c4 },
  { "id": 5, "name": "Michael Brown", "username": "michaelbrown45", "profilePicture": c5 },
  { "id": 6, "name": "Sarah Lee", "username": "sarahlee56", "profilePicture": c6 },
  { "id": 7, "name": "David Kim", "username": "davidkim67", "profilePicture": c1 },
  { "id": 8, "name": "Olivia Patel", "username": "oliviapatel78", "profilePicture": c2 },
  { "id": 9, "name": "William White", "username": "williamwhite89", "profilePicture": c3 },
  { "id": 10, "name": "Ava Martin", "username": "avamartin90", "profilePicture": c4 },
  { "id": 11, "name": "Ethan Hall", "username": "ethanhall01", "profilePicture": c5 },
  { "id": 12, "name": "Lily Davis", "username": "lilydavis12", "profilePicture": c6 }
];

export const admins = [
  {
    "id": 1,
    "name": "Brandly James",
    "username": "branko234",
    "profilePicture": a1
  },
  {
    "id": 2,
    "name": "Samantha Lee",
    "username": "samantha123",
    "profilePicture": a2
  },
  {
    "id": 3,
    "name": "Ethan Brown",
    "username": "ethanb456",
    "profilePicture": a3
  },
  {
    "id": 4,
    "name": "Lily Patel",
    "username": "lilyp789",
    "profilePicture": a4
  },
  {
    "id": 5,
    "name": "Logan White",
    "username": "loganw012",
    "profilePicture": a5
  },
  {
    "id": 6,
    "name": "Ava Kim",
    "username": "avak345",
    "profilePicture": a1
  },
  {
    "id": 7,
    "name": "Noah Martin",
    "username": "noahm678",
    "profilePicture": a2
  },
  {
    "id": 8,
    "name": "Sophia Hall",
    "username": "sophiah901",
    "profilePicture": a3
  },
  {
    "id": 9,
    "name": "Mason Davis",
    "username": "masonD234",
    "profilePicture": a4
  },
  {
    "id": 10,
    "name": "Isabella Taylor",
    "username": "isabellat567",
    "profilePicture": a5
  },
  {
    "id": 11,
    "name": "Alexander Brooks",
    "username": "alexb890",
    "profilePicture": a1
  },
  {
    "id": 12,
    "name": "Charlotte Lewis",
    "username": "charlottel123",
    "profilePicture": a2
  }
];